export default __webpack_public_path__ + "static/media/thumb-NavIC-Chip-2.abcf0271.png";